export const SSO_ERROR_MESSAGE = 'Sign in is temporarily unavailable. Please check back later.'
